import "../../App.scss";
import React, { useState, useEffect } from "react";
import Navbar from "./header/Navbar";
import Dashboard from "./Dashboard/Dashboard";
import AllAgents from "./AllAgents/AllAgents";
import AllTransaction from "./AllTransaction/AllTransaction";
import SalesRound from "./SalesRound/SalesRound";

import Claim from "./AllClaim/Claim";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { Api_Url } from "../../utils/ApiUrl";
import LeadersAdmin from "./LeaderAdmin/LeadersAdmin";
import Accordion from "react-bootstrap/Accordion";
import InstitutionalStat from "./Institutions/InstitutionalStat";
import AllInstitution from "./AllInstitution/AllInstitution";
import InstituteTransaction from "./InstituteTransaction/InstituteTransaction";
import Tokensettings from "./Tokensettings/Tokensettings";
import TestnetRound from "./TestnetRound/TestnetRound";

function Landing() {
  const indexvv = localStorage.getItem("indexvalue");
  const [indexwait, setindexwait] = useState(0);
  const [routes, setRoutes] = useState(false);
  const [user, setUser] = useState(null);

  const val = localStorage.getItem("accessToken");
  const [usdPrice, setUsdPrice] = useState("");
  const [tomiPrice, setTomiPrice] = useState("");
  const [btcPrice, setBtcPrice] = useState("");

  useEffect(() => {
    if (!tomiPrice) {
      getTomiPrice();
    }
    if (!usdPrice) {
      axios
        .get("https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD")
        .then((res) => {
          setUsdPrice(res?.data?.USD);
          // setEthUsd(res.data);
        });
    }
    if (!btcPrice) {
      axios
        .get("https://min-api.cryptocompare.com/data/price?fsym=BTC&tsyms=USD")
        .then((res) => {
          setBtcPrice(res?.data?.USD);
          // setEthUsd(res.data);
        });
    }
  }, []);

  const getTomiPrice = async () => {
    try {
      var config = {
        method: "get",
        url: `${Api_Url}/users/tomi-price`,
      };

      axios(config)
        .then(function (res) {
          setTomiPrice(res?.data?.data);
        })
        .catch(function (error) {
          console.log(error);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
      // throw error;
    }
  };

  useEffect(() => {
    const checkTokenExpiry = () => {
      if (!val) {
        // Token is not present, user is not logged in
        return;
      }

      // Split the JWT into its parts (header, payload, and signature)
      const parts = val?.split(".");
      if (parts.length !== 3) {
        // Invalid JWT format
        return;
      }

      // Decode the payload
      const payload = JSON.parse(atob(parts[1]));

      // Get the expiration time from the payload
      const expirationTime = payload.exp * 1000; // Convert to milliseconds
      const currentTime = Date.now();

      if (expirationTime < currentTime) {
        // Token has expired
        Logout(); // Call the logout function
      }
    };

    // Check token expiry every minute (you can adjust the interval as needed)
    const intervalId = setInterval(checkTokenExpiry, 60000);
    // Clean up the interval when the component unmounts
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const history = useHistory();
  useEffect(() => {
    if (val) {
    } else {
      history.push("/login");
    }
    if (indexvv == "0") {
      setindexwait(0);
    } else if (indexvv == "1") {
      setindexwait(1);
    } else if (indexvv == "2") {
      setindexwait(2);
    } else if (indexvv == "3") {
      setindexwait(3);
    } else if (indexvv == "4") {
      setindexwait(4);
    } else if (indexvv == "5") {
      setindexwait(5);
    } else if (indexvv == "6") {
      setindexwait(6);
    } else if (indexvv == "7") {
      setindexwait(7);
    } else if (indexvv == "8") {
      setindexwait(8);
    } else if (indexvv == "9") {
      setindexwait(9);
    }
    // else if (indexvv == "16") {
    //   setindexwait(16);
    // }
  }, []);
  const hitfunctionss = (asd) => {
    setindexwait(asd);
    localStorage.setItem("indexvalue", asd);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    let res = localStorage.getItem("userId");
    res = JSON.parse(res);
    GetMyData();
    // setUser(res);
  }, []);

  const GetMyData = async () => {
    const tok = localStorage?.getItem("accessToken");
    // if (account) {
    var config = {
      method: "get",
      url: `${Api_Url}/users/my/stats?privateSale=GEMS`,
      // remove the private sale url from here
      headers: {
        authorization: `Bearer ` + tok,
      },
    };
    axios(config)
      .then(function (response) {
        setUser(response?.data?.data);
      })
      .catch(function (error) {
        if (error?.response?.status == 401) {
          // history.push("/login");
        }
        console.log(error);
      });
    // }
  };
  // console.log("user?.role", user?.role);
  const [sidebar, setSidebar] = useState(false);

  const Logout = async () => {
    const val = localStorage.getItem("accessToken");
    var config = {
      method: "delete",
      url: `${Api_Url}/auth/users/logout`,
      headers: {
        Authorization: "Bearer " + val,
      },
    };
    axios(config)
      .then(function (response) {
        if (response?.data?.statusCode == 200) {
          localStorage?.removeItem("accessToken");
          localStorage?.removeItem("refreshToken");
          localStorage?.removeItem("userName");
          history.push("/login");
        }
      })
      .catch(function (error) {
        if (error?.response?.status == 401) {
          localStorage.removeItem("accessToken");
          history.push("/login");
        }
      });
  };

  return (
    <>
      <Navbar
        sidebar={sidebar}
        setSidebar={setSidebar}
        user={user}
        GetMyData={GetMyData}
        setindexwait={setindexwait}
        indexwait={indexwait}
      />
      {indexwait == 0 ? (
        <>
          <Dashboard
            setUser={setUser}
            user={user}
            tomiPrice={tomiPrice}
            usdPrice={usdPrice}
            btcPrice={btcPrice}
          />
        </>
      ) : indexwait == 1 ? (
        <>
          <AllAgents
            GetMyData={GetMyData}
            setindexwait={setindexwait}
            user={user}
            setRoutes={setRoutes}
            routes={routes}
            tomiPrice={tomiPrice}
            usdPrice={usdPrice}
            btcPrice={btcPrice}
          />
        </>
      ) : indexwait == 2 ? (
        <AllTransaction
          setindexwait={setindexwait}
          user={user}
          tomiPrice={tomiPrice}
          usdPrice={usdPrice}
          btcPrice={btcPrice}
        />
      ) : indexwait == 3 ? (
        <>
          {user?.role === "admin" && (
            <SalesRound
              setindexwait={setindexwait}
              tomiPrice={tomiPrice}
              usdPrice={usdPrice}
              btcPrice={btcPrice}
            />
          )}
        </>
      ) : indexwait == 4 ? (
        <>
          {
            user?.role === "admin" ? (
              <Claim
                setindexwait={setindexwait}
                tomiPrice={tomiPrice}
                usdPrice={usdPrice}
                btcPrice={btcPrice}
              />
            ) : null
            // <LeadersAdmin
            //   setindexwait={setindexwait}
            //   tomiPrice={tomiPrice}
            //   usdPrice={usdPrice}
            //   btcPrice={btcPrice}
            //   user={user}
            // />
          }
        </>
      ) : indexwait == 5 ? (
        <>
          <InstitutionalStat
            user={user}
            tomiPrice={tomiPrice}
            usdPrice={usdPrice}
            btcPrice={btcPrice}
          />
        </>
      ) : indexwait == 6 ? (
        <>
          <AllInstitution
            user={user}
            routes={routes}
            setRoutes={setRoutes}
            setindexwait={setindexwait}
            tomiPrice={tomiPrice}
            usdPrice={usdPrice}
            btcPrice={btcPrice}
          />
        </>
      ) : indexwait == 7 ? (
        <>
          <InstituteTransaction
            setindexwait={setindexwait}
            user={user}
            tomiPrice={tomiPrice}
            btcPrice={btcPrice}
          />
        </>
      ) : indexwait == 8 ? (
        <>
          <Tokensettings
            user={user}
            routes={routes}
            setRoutes={setRoutes}
            setindexwait={setindexwait}
            tomiPrice={tomiPrice}
            usdPrice={usdPrice}
            btcPrice={btcPrice}
          />
        </>
      ) : (
        // : indexwait == 9 ? (
        //   <>
        //     <TestnetRound
        //       user={user}
        //       tomiPrice={tomiPrice}
        //       btcPrice={btcPrice}
        //       usdPrice={usdPrice}
        //     />
        //   </>
        // )
        ""
      )}

      {sidebar && (
        <div className="custom-sidebar">
          <div className="custom-sidebar-top-menu d-none">
            <a onClick={() => setSidebar(!sidebar)} class="navbar-brand">
              <img
                src={sidebar ? "/assets/close-icon.svg" : "/assets/bar.svg"}
                alt="img"
                className="img-fluid"
              />
            </a>
            <a
              class="navbar-brand"
              onClick={() => {
                setindexwait(0);
                setSidebar(false);
              }}
            >
              <img src="\logo.svg" alt="img" className="img-fluid" />
            </a>
          </div>
          <ul>
            <li>
              <a
                className={indexwait === 0 ? "active" : ""}
                onClick={() => {
                  hitfunctionss(0);
                  setSidebar(false);
                }}
              >
                <img
                  src="\assets\sidebar\dashboard.svg"
                  alt="img"
                  className="img-fluid"
                />
                Dashboard
              </a>
            </li>
            {user?.role !== "mini_agent" && (
              <li>
                <a
                  className={indexwait === 1 ? "active" : ""}
                  onClick={() => {
                    hitfunctionss(1);
                    setSidebar(false);
                    setRoutes(false);
                  }}
                >
                  <img
                    src="\assets\sidebar\allagents.svg"
                    alt="img"
                    className="img-fluid"
                  />
                  All Leaders
                </a>
              </li>
            )}
            <li>
              <a
                className={indexwait === 2 ? "active" : ""}
                onClick={() => {
                  hitfunctionss(2);
                  setSidebar(false);
                }}
              >
                <img
                  src="\assets\sidebar\allltransaction.svg"
                  alt="img"
                  className="img-fluid"
                />
                All Transactions
              </a>
            </li>
            {user?.role === "admin" && (
              <>
                <li>
                  <a
                    className={indexwait === 3 ? "active" : ""}
                    onClick={() => {
                      hitfunctionss(3);
                      setSidebar(false);
                    }}
                  >
                    <img
                      src="\assets\sidebar\salesround.svg"
                      alt="img"
                      className="img-fluid"
                    />
                    Sale Rounds
                  </a>
                </li>
              </>
            )}
            {
              user?.role === "admin" ? (
                <li>
                  <a
                    className={indexwait === 3 ? "active" : ""}
                    onClick={() => {
                      hitfunctionss(4);
                      setSidebar(false);
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M5.5 7C5.5 6.33696 5.76339 5.70107 6.23223 5.23223C6.70107 4.76339 7.33696 4.5 8 4.5C8.66304 4.5 9.29893 4.76339 9.76777 5.23223C10.2366 5.70107 10.5 6.33696 10.5 7C10.5 7.66304 10.2366 8.29893 9.76777 8.76777C9.29893 9.23661 8.66304 9.5 8 9.5C7.33696 9.5 6.70107 9.23661 6.23223 8.76777C5.76339 8.29893 5.5 7.66304 5.5 7ZM8 3C6.93913 3 5.92172 3.42143 5.17157 4.17157C4.42143 4.92172 4 5.93913 4 7C4 8.06087 4.42143 9.07828 5.17157 9.82843C5.92172 10.5786 6.93913 11 8 11C9.06087 11 10.0783 10.5786 10.8284 9.82843C11.5786 9.07828 12 8.06087 12 7C12 5.93913 11.5786 4.92172 10.8284 4.17157C10.0783 3.42143 9.06087 3 8 3ZM15.5 8C15.5 7.60218 15.658 7.22064 15.9393 6.93934C16.2206 6.65804 16.6022 6.5 17 6.5C17.3978 6.5 17.7794 6.65804 18.0607 6.93934C18.342 7.22064 18.5 7.60218 18.5 8C18.5 8.39782 18.342 8.77936 18.0607 9.06066C17.7794 9.34196 17.3978 9.5 17 9.5C16.6022 9.5 16.2206 9.34196 15.9393 9.06066C15.658 8.77936 15.5 8.39782 15.5 8ZM17 5C16.2044 5 15.4413 5.31607 14.8787 5.87868C14.3161 6.44129 14 7.20435 14 8C14 8.79565 14.3161 9.55871 14.8787 10.1213C15.4413 10.6839 16.2044 11 17 11C17.7956 11 18.5587 10.6839 19.1213 10.1213C19.6839 9.55871 20 8.79565 20 8C20 7.20435 19.6839 6.44129 19.1213 5.87868C18.5587 5.31607 17.7956 5 17 5ZM11.75 13C12.051 13 12.338 13.06 12.601 13.166C12.2923 13.2855 12.0103 13.4648 11.7712 13.6938C11.5321 13.9227 11.3407 14.1967 11.208 14.5H4.25C4.05109 14.5 3.86032 14.579 3.71967 14.7197C3.57902 14.8603 3.5 15.0511 3.5 15.25V15.507L3.507 15.587C3.514 15.661 3.53 15.775 3.562 15.916C3.628 16.197 3.76 16.572 4.021 16.945C4.514 17.65 5.578 18.5 8 18.5C9.407 18.5 10.355 18.213 11 17.835V19.496C10.209 19.808 9.223 20 8 20C5.172 20 3.61 18.975 2.792 17.805C2.36404 17.1907 2.09658 16.4791 2.014 15.735C2.00699 15.6665 2.00232 15.5978 2 15.529V15.251C1.99987 14.9554 2.05797 14.6628 2.17098 14.3897C2.284 14.1166 2.44971 13.8684 2.65866 13.6594C2.8676 13.4503 3.11568 13.2845 3.38873 13.1714C3.66178 13.0582 3.95444 13 4.25 13H11.75ZM12 15.5C12 15.1022 12.158 14.7206 12.4393 14.4393C12.7206 14.158 13.1022 14 13.5 14H21.5C21.8978 14 22.2794 14.158 22.5607 14.4393C22.842 14.7206 23 15.1022 23 15.5V19.5C23 19.8978 22.842 20.2794 22.5607 20.5607C22.2794 20.842 21.8978 21 21.5 21H13.5C13.1022 21 12.7206 20.842 12.4393 20.5607C12.158 20.2794 12 19.8978 12 19.5V15.5ZM13 16V17C13.5304 17 14.0391 16.7893 14.4142 16.4142C14.7893 16.0391 15 15.5304 15 15H14C14 15.2652 13.8946 15.5196 13.7071 15.7071C13.5196 15.8946 13.2652 16 13 16ZM22 17V16C21.7348 16 21.4804 15.8946 21.2929 15.7071C21.1054 15.5196 21 15.2652 21 15H20C20 15.5304 20.2107 16.0391 20.5858 16.4142C20.9609 16.7893 21.4696 17 22 17ZM20 20H21C21 19.7348 21.1054 19.4804 21.2929 19.2929C21.4804 19.1054 21.7348 19 22 19V18C21.4696 18 20.9609 18.2107 20.5858 18.5858C20.2107 18.9609 20 19.4696 20 20ZM13 18V19C13.2652 19 13.5196 19.1054 13.7071 19.2929C13.8946 19.4804 14 19.7348 14 20H15C15 19.4696 14.7893 18.9609 14.4142 18.5858C14.0391 18.2107 13.5304 18 13 18ZM17.5 19.25C17.9641 19.25 18.4092 19.0656 18.7374 18.7374C19.0656 18.4092 19.25 17.9641 19.25 17.5C19.25 17.0359 19.0656 16.5908 18.7374 16.2626C18.4092 15.9344 17.9641 15.75 17.5 15.75C17.0359 15.75 16.5908 15.9344 16.2626 16.2626C15.9344 16.5908 15.75 17.0359 15.75 17.5C15.75 17.9641 15.9344 18.4092 16.2626 18.7374C16.5908 19.0656 17.0359 19.25 17.5 19.25Z"
                        fill="white"
                      />
                    </svg>
                    Leader Claims
                  </a>
                </li>
              ) : null
              // <li>
              //   <a
              //     className={indexwait === 3 ? "active" : ""}
              //     onClick={() => {
              //       hitfunctionss(4);
              //       setSidebar(false);
              //     }}
              //   >
              //     <svg
              //       xmlns="http://www.w3.org/2000/svg"
              //       width="24"
              //       height="24"
              //       viewBox="0 0 24 24"
              //       fill="none"
              //     >
              //       <path
              //         d="M20.1611 11.2583H3.83883C3.01932 11.2583 2.35498 11.9226 2.35498 12.7421V20.1614C2.35498 20.9809 3.01932 21.6452 3.83883 21.6452H20.1611C20.9806 21.6452 21.645 20.9809 21.645 20.1614V12.7421C21.645 11.9226 20.9806 11.2583 20.1611 11.2583Z"
              //         stroke="white"
              //         stroke-width="1.5"
              //         stroke-linecap="round"
              //         stroke-linejoin="round"
              //       />
              //       <path
              //         d="M6.80664 4.58075V7.54844M12.0001 2.35498V7.54844M17.1936 4.58075V7.54844"
              //         stroke="white"
              //         stroke-width="1.5"
              //         stroke-linecap="round"
              //         stroke-linejoin="round"
              //       />
              //       <path
              //         d="M11.9999 18.6771C13.2292 18.6771 14.2257 17.6806 14.2257 16.4514C14.2257 15.2221 13.2292 14.2256 11.9999 14.2256C10.7707 14.2256 9.77417 15.2221 9.77417 16.4514C9.77417 17.6806 10.7707 18.6771 11.9999 18.6771Z"
              //         stroke="white"
              //         stroke-width="1.5"
              //         stroke-linecap="round"
              //         stroke-linejoin="round"
              //       />
              //     </svg>
              //     My Claims
              //   </a>
              // </li>
            }
            {user?.role === "admin" && (
              <li>
                <Accordion className="institute-accord">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <a
                        className={
                          indexwait === 5
                            ? "d-flex justify-content-between align-center active"
                            : "d-flex justify-content-between align-center"
                        }
                      >
                        <div>
                          <img
                            src="\assets\sidebar\institutional.svg"
                            alt="img"
                            className="img-fluid me-2"
                          />
                          Institutions
                        </div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="8"
                          viewBox="0 0 14 8"
                          fill="none"
                        >
                          <path
                            d="M12.9181 0.178772H6.6881H1.0781C0.1181 0.178772 -0.361899 1.33877 0.318101 2.01877L5.4981 7.19877C6.3281 8.02877 7.6781 8.02877 8.5081 7.19877L10.4781 5.22877L13.6881 2.01877C14.3581 1.33877 13.8781 0.178772 12.9181 0.178772Z"
                            fill="white"
                          />
                        </svg>
                      </a>
                    </Accordion.Header>
                    <Accordion.Body>
                      <a
                        onClick={() => {
                          hitfunctionss(5);
                          setSidebar(false);
                        }}
                      >
                        Institutions Stats
                      </a>
                      <a
                        onClick={() => {
                          hitfunctionss(6);
                          setSidebar(false);
                        }}
                      >
                        All Institutions
                      </a>
                      <a
                        onClick={() => {
                          hitfunctionss(7);
                          setSidebar(false);
                        }}
                      >
                        All Transactions
                      </a>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </li>
            )}
            {user?.role == "admin" ? (
              <li>
                <a
                  className={indexwait === 8 ? "active" : ""}
                  onClick={() => {
                    hitfunctionss(8);
                    setSidebar(false);
                  }}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="fi_2682917" clip-path="url(#clip0_3595_9665)">
                      <g id="Group">
                        <path
                          id="Vector"
                          d="M14.1201 9.08192L12.6305 6.06374C12.5121 5.82374 12.2676 5.67181 12 5.67181C11.7324 5.67181 11.488 5.82378 11.3695 6.06374L9.87995 9.08192L6.5492 9.56591C6.28436 9.60439 6.06428 9.78992 5.98159 10.0445C5.89886 10.299 5.96786 10.5784 6.15948 10.7652L8.56965 13.1145L8.00069 16.4318C7.95545 16.6956 8.06387 16.9622 8.28039 17.1195C8.49695 17.2768 8.78397 17.2976 9.02087 17.1731L12 15.6068L14.9791 17.173C15.2174 17.2983 15.5043 17.2758 15.7196 17.1194C15.9361 16.9621 16.0446 16.6955 15.9993 16.4317L15.4303 13.1144L17.8405 10.7651C18.0321 10.5783 18.1011 10.2989 18.0184 10.0444C17.9357 9.78983 17.7157 9.6043 17.4508 9.56581L14.1201 9.08192ZM14.1841 12.3655C14.0184 12.527 13.9427 12.7598 13.9818 12.9879L14.3725 15.2653L12.3272 14.1901C12.2248 14.1362 12.1124 14.1093 12 14.1093C11.8877 14.1093 11.7752 14.1362 11.6728 14.1901L9.62758 15.2653L10.0182 12.9879C10.0573 12.7598 9.98167 12.527 9.81597 12.3655L8.16133 10.7526L10.448 10.4204C10.677 10.3871 10.875 10.2433 10.9774 10.0357L12 7.96367L13.0226 10.0357C13.1251 10.2433 13.3231 10.3871 13.552 10.4204L15.8387 10.7526L14.1841 12.3655Z"
                          fill="white"
                        />
                        <path
                          id="Vector_2"
                          d="M12 0C5.39255 0 0 5.39297 0 12C0 18.6075 5.39297 24 12 24C18.6075 24 24 18.607 24 12C24 5.39255 18.607 0 12 0ZM12 22.5938C6.15858 22.5938 1.40625 17.8414 1.40625 12C1.40625 6.15858 6.15858 1.40625 12 1.40625C17.8414 1.40625 22.5938 6.15858 22.5938 12C22.5938 17.8414 17.8414 22.5938 12 22.5938Z"
                          fill="white"
                        />
                        <path
                          id="Vector_3"
                          d="M12 2.8125C6.95447 2.8125 2.8125 6.95405 2.8125 12C2.8125 17.0455 6.95405 21.1875 12 21.1875C17.0455 21.1875 21.1875 17.046 21.1875 12C21.1875 6.95447 17.046 2.8125 12 2.8125ZM12 19.7812C7.70939 19.7812 4.21875 16.2906 4.21875 12C4.21875 7.70939 7.70939 4.21875 12 4.21875C16.2906 4.21875 19.7812 7.70939 19.7812 12C19.7812 16.2906 16.2906 19.7812 12 19.7812Z"
                          fill="white"
                        />
                      </g>
                    </g>
                    <defs>
                      <clipPath id="clip0_3595_9665">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  Token Settings
                </a>
              </li>
            ) : null}
            {/* <li>
              <a
                className={indexwait === 9 ? "active" : ""}
                onClick={() => {
                  hitfunctionss(9);
                  setSidebar(false);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M17.9998 7.91002C17.9698 7.91002 17.9498 7.91002 17.9198 7.91002H17.8698C15.9798 7.85002 14.5698 6.39001 14.5698 4.59001C14.5698 2.75001 16.0698 1.26001 17.8998 1.26001C19.7298 1.26001 21.2298 2.76001 21.2298 4.59001C21.2198 6.40001 19.8098 7.86001 18.0098 7.92001C18.0098 7.91001 18.0098 7.91002 17.9998 7.91002ZM17.8998 2.75002C16.8898 2.75002 16.0698 3.57002 16.0698 4.58002C16.0698 5.57002 16.8398 6.37002 17.8298 6.41002C17.8398 6.40002 17.9198 6.40002 18.0098 6.41002C18.9798 6.36002 19.7298 5.56002 19.7398 4.58002C19.7398 3.57002 18.9198 2.75002 17.8998 2.75002Z"
                    fill="white"
                  />
                  <path
                    d="M18.01 15.28C17.62 15.28 17.23 15.25 16.84 15.18C16.43 15.11 16.16 14.72 16.23 14.31C16.3 13.9 16.69 13.63 17.1 13.7C18.33 13.91 19.63 13.68 20.5 13.1C20.97 12.79 21.22 12.4 21.22 12.01C21.22 11.62 20.96 11.24 20.5 10.93C19.63 10.35 18.31 10.12 17.07 10.34C16.66 10.42 16.27 10.14 16.2 9.73002C16.13 9.32002 16.4 8.93003 16.81 8.86003C18.44 8.57003 20.13 8.88002 21.33 9.68002C22.21 10.27 22.72 11.11 22.72 12.01C22.72 12.9 22.22 13.75 21.33 14.35C20.42 14.95 19.24 15.28 18.01 15.28Z"
                    fill="white"
                  />
                  <path
                    d="M5.96998 7.91C5.95998 7.91 5.94998 7.91 5.94998 7.91C4.14998 7.85 2.73998 6.39 2.72998 4.59C2.72998 2.75 4.22998 1.25 6.05998 1.25C7.88998 1.25 9.38998 2.75 9.38998 4.58C9.38998 6.39 7.97998 7.85 6.17998 7.91L5.96998 7.16L6.03998 7.91C6.01998 7.91 5.98998 7.91 5.96998 7.91ZM6.06998 6.41C6.12998 6.41 6.17998 6.41 6.23998 6.42C7.12998 6.38 7.90998 5.58 7.90998 4.59C7.90998 3.58 7.08998 2.75999 6.07998 2.75999C5.06998 2.75999 4.24998 3.58 4.24998 4.59C4.24998 5.57 5.00998 6.36 5.97998 6.42C5.98998 6.41 6.02998 6.41 6.06998 6.41Z"
                    fill="white"
                  />
                  <path
                    d="M5.96 15.28C4.73 15.28 3.55 14.95 2.64 14.35C1.76 13.76 1.25 12.91 1.25 12.01C1.25 11.12 1.76 10.27 2.64 9.68002C3.84 8.88002 5.53 8.57003 7.16 8.86003C7.57 8.93003 7.84 9.32002 7.77 9.73002C7.7 10.14 7.31 10.42 6.9 10.34C5.66 10.12 4.35 10.35 3.47 10.93C3 11.24 2.75 11.62 2.75 12.01C2.75 12.4 3.01 12.79 3.47 13.1C4.34 13.68 5.64 13.91 6.87 13.7C7.28 13.63 7.67 13.91 7.74 14.31C7.81 14.72 7.54 15.11 7.13 15.18C6.74 15.25 6.35 15.28 5.96 15.28Z"
                    fill="white"
                  />
                  <path
                    d="M11.9998 15.38C11.9698 15.38 11.9498 15.38 11.9198 15.38H11.8698C9.97982 15.32 8.56982 13.86 8.56982 12.06C8.56982 10.22 10.0698 8.72998 11.8998 8.72998C13.7298 8.72998 15.2298 10.23 15.2298 12.06C15.2198 13.87 13.8098 15.33 12.0098 15.39C12.0098 15.38 12.0098 15.38 11.9998 15.38ZM11.8998 10.22C10.8898 10.22 10.0698 11.04 10.0698 12.05C10.0698 13.04 10.8398 13.84 11.8298 13.88C11.8398 13.87 11.9198 13.87 12.0098 13.88C12.9798 13.83 13.7298 13.03 13.7398 12.05C13.7398 11.05 12.9198 10.22 11.8998 10.22Z"
                    fill="white"
                  />
                  <path
                    d="M11.9998 22.76C10.7998 22.76 9.59978 22.45 8.66978 21.82C7.78978 21.23 7.27979 20.39 7.27979 19.49C7.27979 18.6 7.77978 17.74 8.66978 17.15C10.5398 15.91 13.4698 15.91 15.3298 17.15C16.2098 17.74 16.7198 18.58 16.7198 19.48C16.7198 20.37 16.2198 21.23 15.3298 21.82C14.3998 22.44 13.1998 22.76 11.9998 22.76ZM9.49979 18.41C9.02979 18.72 8.77979 19.11 8.77979 19.5C8.77979 19.89 9.03979 20.27 9.49979 20.58C10.8498 21.49 13.1398 21.49 14.4898 20.58C14.9598 20.27 15.2098 19.88 15.2098 19.49C15.2098 19.1 14.9498 18.72 14.4898 18.41C13.1498 17.5 10.8598 17.51 9.49979 18.41Z"
                    fill="white"
                  />
                </svg>
                Testnet Round
              </a>
            </li> */}
          </ul>
          <Navbar setSidebar={setSidebar} mobileNav={true} />
          <button onClick={() => Logout()} className="logout-btn d-none">
            <img
              src="\assets\logout-icon.svg"
              alt="img"
              className="img-fluid"
            />
            Logout
          </button>
        </div>
      )}
    </>
  );
}

export default Landing;
